<template>
    <div id="header" class="d-flex flex-column justify-content-center align-items-center">
        <div id="ibisstylesLogo"></div>
        <div id="date">{{ date }}</div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'IbisStylesRatesHorizontalV1Header',
  props: {
  },
  data () {
    return {
      date: ''
    }
  },
  mounted () {
    this.refreshDate()
  },
  computed: {
    test () {
      return this.$route.query.test
    }
  },
  methods: {
    refreshDate () {
      moment.locale('fr')
      this.date = moment().format('dddd LL - LT')
      setTimeout(this.refreshDate, 60000)
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_ibisstyles.scss";

#header {
    width: 100%;
    @include heightPercent(176);
    font-size: 1.3rem;
    font-family: "Gotham-Light";
    color: black;
    text-align: center;
    text-transform: capitalize;
    margin-top: 20 * 100vh / $srcHeight;

    #ibisstylesLogo {
        @include widthPercent(502);
        @include heightPercent(154);
        height: 100%;
        background: url(./assets/logoIbisStyles.png) no-repeat;
        background-size: contain;
    }

    #date {
        @include fontSize(20);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ibisstyles/rates/horizontal/v1/header.vue